<template>
  <div class="sprint-header">
    <BaseHeading
      level="2"
      color="monochrome-07"
      className="sprint-header__title"
    >
      <icon
        v-if="sprint.continuousSprint"
        data="@icon/continuous-sprint.svg"
        class="sprint-header__icon continuous-sprint__icon"
        :class="[`is-${sprint.status.toLowerCase()}`]"
        :fill="true"
        width="var(--icon-24)"
        height="var(--icon-24)"
      />
      <icon
        v-else-if="sprint.zeroSprint"
        data="@icon/zero-sprint.svg"
        class="sprint-header__icon zero-sprint__icon"
        :class="[`is-${sprint.status.toLowerCase()}`]"
        :fill="true"
        width="var(--icon-24)"
        height="var(--icon-24)"
      />
      <div
        v-else
        class="sprint-header__icon dot sprint-header__dot"
        :class="[`is-${sprint.status.toLowerCase()}`]"
      />
      <slot
        name="title"
        :title="title"
      >
        {{ title }}
      </slot>
    </BaseHeading>

    <BaseSubHeading
      v-if="showDate"
      size="large"
      :isDark="isDark"
      :style="{ color: isDark ? 'var(--monochrome-04)' : 'var(--monochrome-05)' }"
      className="sprint-header__sub-title"
      weight="500"
    >
      <slot
        name="date"
        :startDate="sprint.formatedDateStart"
        :endDate="sprint.formatedDateEnd"
      >
        {{ sprint.formatedDateStart }} - {{ sprint.formatedDateEnd }}
      </slot>

      <icon
        v-if="sprint.isHalted && $route.path.includes('/review')"
        v-tooltip.bottom="{ content: sprint.haltReason, theme: 'info-tooltip-alert' }"
        data="@icon/alert-tooltip.svg"
        class="icon-alert-tooltip"
        :fill="true"
        width="var(--icon-24)"
        height="var(--icon-24)"
        color="var(--serviceAlert-02)"
      />
    </BaseSubHeading>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component"
import { Prop } from "vue-property-decorator"
import { Getter } from "s-vuex-class"

import { Sprint } from "@/models"
import { $t } from "@/plugins/i18n"
import { Getters } from "@/store"

const components = {}

@Options({
  name: "SprintHeading",
  components
})
export default class extends Vue {
  @Prop({ required: true }) sprint: Sprint
  @Prop({ default: true }) showDate: boolean
  @Getter(Getters.THEME_IS_DARK) readonly isDark: boolean

  get isImportedAndCompletedSprint() {
    return (
      (this.sprint.status === "HALTED" || this.sprint.status === "COMPLETED") &&
      this.sprint.historicalImport
    )
  }

  get title() {
    return this.isImportedAndCompletedSprint
      ? this.sprint?.externalSprintName
      : `${$t("backlog.titles.backlogSprint")} #${this.sprint.sequenceNumber}`
  }
}
</script>
